import React, { Component } from 'react';
import { Image } from 'react-bootstrap';
import Lightbox from 'react-image-lightbox';

import './LightboxComp.css';
 
export default class LightboxComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      isOpen: false,
    };
  }
 
  render() {
    const { photoIndex, isOpen } = this.state;
    if (this.props.images == null || this.props.images.length === 0) {
      return <div/>
    }
    let images = [];
    for (var key in this.props.images) {
      let image = this.props.images[key]
      images.push([image.index, image.downloadURL]);
    }
    let imageUrls = images.sort((a, b) => a[0] - b[0]).map(image => image[1])
    var CoverImage = <Image src={imageUrls[0]} responsive className="cover-image"/>
    return (
      <div>
        <div onClick={() => this.setState({ isOpen: true })}>
          {CoverImage}     
        </div>   
        {isOpen && (
          <Lightbox
            mainSrc={imageUrls[photoIndex]}
            nextSrc={imageUrls[(photoIndex + 1) % imageUrls.length]}
            prevSrc={imageUrls[(photoIndex + imageUrls.length - 1) % imageUrls.length]}
            onCloseRequest={() => this.setState({ isOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + imageUrls.length - 1) % imageUrls.length,
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % imageUrls.length,
              })
            }
          />
        )}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/LightboxComp.js